export default __webpack_public_path__ + "static/media/double-deep.819f00e2.png";